import { Injectable } from "@angular/core";
import { MCCodeListWrapperService, MCSelectItemExtend } from "@maslul/common-services";
import { Observable, map } from "rxjs";
import { MICustomFunctionsParams } from "../../../models/fields/custom-function-params";
import { ApprovalTypeData } from "../../approval-type/approvals-type-data";
import { RequestApprovalTypeDetailsStore } from "../../store/approval-type-details-store";

@Injectable({
    providedIn: 'root'
})
export class CountriesService {

    constructor(private requestApprovalTypeDetailsStore: RequestApprovalTypeDetailsStore) {
    }

    getCountryOfMechesByGroups(customFunctionsObj: MICustomFunctionsParams): Observable<MCSelectItemExtend[]> {
        const countriesService = customFunctionsObj.injector.get(CountriesService);

        const withoutIL = customFunctionsObj.fieldSchema.attributes.find(att => att.key === 'withoutIL')?.value;
        return countriesService.getCountryOfMeches(customFunctionsObj).pipe((map((res: MCSelectItemExtend[]) => {
            if (countriesService.isWithoutCountiesGroup(customFunctionsObj)) {
                res = res.filter(x => x.value == null || x.additionalColumns?.["Filter"] == '1')
            }
            if (withoutIL == "true") {
                res = res.filter(x => x.value == null || x.value != 'IL')
            }
            return res;
        })));

    }

    getCountryOfMeches(customFunctionsObj: MICustomFunctionsParams): Observable<MCSelectItemExtend[]> {
        const codeListService = customFunctionsObj.injector.get(MCCodeListWrapperService);
        return codeListService.getListAllColums('UR_countryOfMeches', true, true, 'UR_', "Translate");
    }

    isWithoutCountiesGroup(_customFunctionsObj: MICustomFunctionsParams): boolean {
        const approvalTypeId = this.requestApprovalTypeDetailsStore.getSnapshot().approvalTypeId;
        return ApprovalTypeData.approvalTypeToExcludeCountriesGroup.find(x => x == approvalTypeId);
    }

}